import {graphql} from 'react-relay';
import type {CalendarEventsFetch_Query$data as CalendarEventsFetch_QueryResponse} from './__generated__/CalendarEventsFetch_Query.graphql';

export type CalendarEventEdges = NonNullable<
	NonNullable<NonNullable<CalendarEventsFetch_QueryResponse['viewer']>['calendarIntegrations']>['calendarEvents']
>['edges'];
export type CalendarEventType = NonNullable<NonNullable<CalendarEventEdges>[0]>['node'];
export const CalendarEventsQuery = graphql`
	query CalendarEventsFetch_Query($start: String, $end: String, $timezone: String) {
		viewer {
			id
			component(name: "google_calendar_events")
			calendarIntegrations {
				calendarEvents(start: $start, end: $end, timezone: $timezone) {
					edges {
						node {
							id
							name
							description
							start
							end
							calendarTimeZone
							allDay
							calendarId
							foregroundColor
							backgroundColor
							attendees
						}
					}
				}
			}
		}
	}
`;
